"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutateObserver = void 0;
const react_1 = require("react");
const useCurrentRef_1 = require("../useCurrentRef");
function useMutateObserver(ele, onMutate) {
    const [lastMutatedAt, setLastMutatedAt] = react_1.useState(0);
    const [mutationList, setMutationList] = react_1.useState([]);
    const onMutateRef = useCurrentRef_1.useCurrentRef(onMutate);
    react_1.useEffect(() => {
        if (!ele) {
            return;
        }
        // Options for the observer (which mutations to observe)
        const config = { childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        const callback = (mutationsList, observer) => {
            var _a;
            setMutationList(mutationsList);
            setLastMutatedAt(Date.now());
            (_a = onMutateRef.current) === null || _a === void 0 ? void 0 : _a.call(onMutateRef, mutationsList);
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(ele, config);
        return () => {
            // Later, you can stop observing
            observer.disconnect();
        };
    }, [ele, onMutateRef]);
    return [lastMutatedAt, mutationList];
}
exports.useMutateObserver = useMutateObserver;
